export const aiDigestPresentation = {
  excerptCharacters: {
    headlinePost: 470,
    compactPost: 175,
    fullQuickTake: 600,
    discussionContext: 220,
    discussionRoot: 680,
    discussionReply: 320,
  },
  previewHtmlCharacters: {
    headlinePost: 780,
    compactPost: 290,
  },
  aiNote: {
    marginTop: 22,
    borderRadius: 6,
    padding: "17px 20px 18px",
    labelMarginBottom: 8,
    labelFontSize: 12,
    labelFontWeight: 600,
    labelLetterSpacing: "1.4px",
    labelLineHeight: 1.2,
    paragraphMargin: "10px 0 0",
    paragraphFontSize: 15,
    paragraphLineHeight: 1.5,
    footerMarginTop: 12,
  },
  section: {
    marginTop: 36,
    titleFontSize: 21,
    titleFontWeight: 500,
    titleLineHeight: 1.2,
    itemSpacing: 24,
  },
  card: {
    borderRadius: 6,
  },
  headline: {
    imageHeight: 220,
    bodyPadding: "20px 24px 14px",
    titleMargin: "0 0 6px",
    titleFontSize: 22,
    titleFontWeight: 500,
    titleLetterSpacing: "-0.3px",
    titleLineHeight: 1.2,
    metadataMarginBottom: 12,
    metadataFontSize: 13,
    metadataLineHeight: 1.4,
    excerptMargin: "0 0 12px",
    excerptFontSize: 16,
    excerptLineHeight: 1.55,
  },
  compact: {
    textPadding: "16px 16px 8px 20px",
    imageWidth: 112,
    imagePadding: "16px 20px 8px 0",
    imageHeight: 76,
    imageBorderRadius: 3,
    titleMargin: "0 0 4px",
    titleFontSize: 17,
    titleFontWeight: 500,
    titleLineHeight: 1.25,
    metadataMarginBottom: 8,
    metadataFontSize: 12.5,
    excerptMargin: "0 0 10px",
    excerptFontSize: 14,
    excerptLineHeight: 1.45,
    footerPadding: "0 20px 14px",
  },
  quickTake: {
    bodyPadding: "14px 16px 12px",
    metaMarginBottom: 8,
    authorFontSize: 13,
    authorFontWeight: 600,
    dateFontSize: 12,
    dateMarginLeft: 8,
    labelPadding: "2px 7px 3px",
    labelBorderRadius: 10,
    labelFontSize: 11,
    labelFontWeight: 600,
    labelLineHeight: 1.2,
    textMargin: "0 0 12px",
    textFontSize: 14.5,
    textLineHeight: 1.5,
  },
  discussion: {
    bodyPadding: "18px 22px 20px",
    titleLineHeight: 1.3,
    threadTitleMargin: "0 0 10px",
    threadTitleFontSize: 16,
    threadTitleFontWeight: 400,
    threadTitleSubjectFontWeight: 500,
    commentMargin: "0 0 10px",
    commentPadding: "10px 12px 12px",
    commentBorderRadius: 3,
    replyMargin: "0 0 6px 8px",
    replyBorderRadius: "2px 0 0 2px",
    bylineMarginBottom: 8,
    bylineFontSize: 13,
    bylineFontWeight: 600,
    dateFontSize: 12,
    dateMarginLeft: 8,
    textFontSize: 14,
    textLineHeight: 1.5,
  },
  footer: {
    paddingTop: 10,
    columnGap: 16,
    rowGap: 8,
    readLinkFontSize: 14,
    reasonFlexBasis: 220,
    reasonFontSize: 12,
    reasonLineHeight: 1.4,
  },
  curated: {
    labelFontSize: 11,
    labelFontWeight: 600,
    labelLetterSpacing: "1.8px",
    labelLineHeight: 1.2,
    labelPaddingRight: 12,
    firstItemPaddingTop: 14,
    itemPaddingTop: 12,
    itemLineHeight: 1.35,
    titleFontSize: 16,
    titleFontWeight: 500,
    bylineFontSize: 13,
    bylineMarginLeft: 8,
  },
  missingItem: {
    padding: "14px 0",
    fontSize: 12,
  },
};
